"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _Message = require("../../../ui-components/Message");

var _ExternalLink = require("../../../ui-components/ExternalLink");

var _CrmImportInputFields = _interopRequireDefault(require("./CrmImportInputFields"));

var _IntegrationPanelItems = require("../integration-panel/IntegrationPanelItems");

var _constants = require("@insided/shared/constants");

function getCrmImportIntegrationPanel(props) {
  var isProduction = props.isProduction,
      instanceType = props.instanceType,
      isInstalled = props.isInstalled,
      isSettingEnabled = props.isSettingEnabled,
      _onSave = props.onSave,
      _onCancel = props.onCancel,
      _onSettingChanged = props.onSettingChanged,
      showActionButtons = props.showActionButtons,
      hasUnsavedChanges = props.hasUnsavedChanges,
      onClickPanelCallback = props.onClickPanelCallback,
      storedState = props.storedState,
      fieldApiName = props.fieldApiName,
      valueApiName = props.valueApiName,
      _onCrmImportMappingFieldApiNameChanged = props.onCrmImportMappingFieldApiNameChanged,
      _onCrmImportMappingPicklistValueChanged = props.onCrmImportMappingPicklistValueChanged,
      isLoading = props.isLoading;
  return {
    title: (0, _preact.h)(_IntegrationPanelItems.IntegrationPanelHeaderTitle, {
      title: "Import Salesforce Account data to ".concat(_constants.PLATFORM_BRAND_NAME),
      isInstalled: isInstalled,
      storedIsSettingEnabled: storedState.isCrmImportEnabled,
      imageFromName: "salesforce-s",
      imageToName: _constants.PLATFORM_INTEGRATION_LOGO_S_FILENAME
    }),
    body: isProduction && instanceType === 'Sandbox' ? (0, _preact.h)(CrmImportIntegrationPanelBodyDisabled, null) : (0, _preact.h)(_IntegrationPanelItems.IntegrationPanelBodyWithToggleSetting, {
      isInstalled: isInstalled,
      isSettingEnabled: isSettingEnabled,
      onSettingChanged: function onSettingChanged() {
        return _onSettingChanged(!isSettingEnabled);
      },
      onSave: function onSave() {
        return _onSave();
      },
      onCancel: function onCancel() {
        return _onCancel();
      },
      showActionButtons: showActionButtons,
      toggleLabel: "Automatically import Salesforce accounts to ".concat(_constants.PLATFORM_BRAND_NAME),
      communityArticleLink: "https://community.insided.com/integrations-124/how-to-measure-monthly-active-customers-on-insided-via-salesforce-3145",
      description: "Measure community engagement in the context of your entire customer base on our engagement dashboard, by importing Salesforce account data to ".concat(_constants.PLATFORM_BRAND_NAME, "."),
      additionalHelpText: (0, _preact.h)("span", null, "On the ", (0, _preact.h)("a", {
        className: "overview-page-link",
        target: "_blank",
        href: (0, _absoluteUrlRuntime.resolveUrl)("/analyticsV2/engagement")
      }, "Engagement dashboard"), ", you\u2019ll be able to see which customers have been active on the community. "),
      storedIsSettingEnabled: storedState.isCrmImportEnabled,
      additionalInputFields: (0, _preact.h)(_CrmImportInputFields.default, {
        fieldApiName: fieldApiName,
        valueApiName: valueApiName,
        onCrmImportMappingFieldApiNameChanged: function onCrmImportMappingFieldApiNameChanged(fieldApiName) {
          return _onCrmImportMappingFieldApiNameChanged(fieldApiName);
        },
        onCrmImportMappingPicklistValueChanged: function onCrmImportMappingPicklistValueChanged(valueApiName) {
          return _onCrmImportMappingPicklistValueChanged(valueApiName);
        }
      }),
      isLoading: isLoading
    }),
    hasUnsavedChanges: hasUnsavedChanges,
    customClass: 'integration__panel qa-crm-import',
    onClickPanel: function onClickPanel(selectedPanel) {
      return onClickPanelCallback(selectedPanel);
    }
  };
}

var CrmImportIntegrationPanelBodyDisabled = function CrmImportIntegrationPanelBodyDisabled() {
  return (0, _preact.h)("div", {
    className: "panel-body-container"
  }, (0, _preact.h)("div", {
    className: "panel-body-instructions"
  }, "Measure community engagement in the context of your entire customer base on our engagement dashboard, by importing Salesforce account data to ", _constants.PLATFORM_BRAND_NAME, "."), (0, _preact.h)(_Message.Message, {
    variant: "warning",
    text: "It's not possible to import Salesforce account data from a sandbox instance. Please use a production instance instead to enable this integration. To test this integration with a sandbox instance, please log in to your ".concat(_constants.PLATFORM_BRAND_NAME, " staging environment.")
  }), (0, _preact.h)(_ExternalLink.ExternalLink, {
    label: "Learn more about this integration",
    url: "https://community.insided.com/",
    isExternalLinkForToggle: false
  }));
};

var _default = getCrmImportIntegrationPanel;
exports.default = _default;